import { isBrowser } from '@firsttable/functions';

export const getPermissionsListFromToken = (token?: string): string[] => {
  if (!isBrowser || !token) {
    return [];
  }

  try {
    const payload = token.split('.')[1];
    if (!payload) {
      return [];
    }

    const normalizedPayload = payload.replace(/-/g, '+').replace(/_/g, '/');
    const paddedPayload = `${normalizedPayload}${'='.repeat(
      (4 - (normalizedPayload.length % 4)) % 4
    )}`;
    const permissions = JSON.parse(JSON.parse(window.atob(paddedPayload)).sub).permissionsList;
    return Array.isArray(permissions) ? permissions : [];
  } catch {
    return [];
  }
};
